import { render } from "./psp-tags-page.vue?vue&type=template&id=3381ba58&ts=true"
import script from "./psp-tags-page.ts?vue&type=script&lang=ts"
export * from "./psp-tags-page.ts?vue&type=script&lang=ts"

import "./psp-tags-page.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__